/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomDetailEnum {
    INDIVIDUAL = 'INDIVIDUAL',
    VEHICLE = 'VEHICLE',
}
